( function( $ ) {
    'use strict';

    // $(document).ready(function(){
    $(window).on('load', function() {
        let course_Id;
        let $body = $( 'body' ),
            $mainContentEl = $( 'article.main-content' );


        if( window.location.hash ) {
            if (window.location.hash.indexOf('?') == -1) {
                  course_Id = window.location.hash;
            }else{
                  course_Id = window.location.hash.split('?')[0];
            }
            const courseId = course_Id;
            //const courseId = window.location.hash;
            
            let $courseModalWrapper = $( courseId );

            if ( $courseModalWrapper && $courseModalWrapper.length && $courseModalWrapper.hasClass( 'aw-modal-wrapper' ) ){
                awShowModal( $courseModalWrapper );
            } else {
                let $course = $( `[data-target="${ courseId }--modal"]` );

                if ( $course && $course.length ){
                    $( [document.documentElement, document.body] ).animate( {
                        scrollTop: $course.offset().top
                    }, 600 );
                    $course.click();
                }
            }
        }

        window.awShowModal = function( $modalWrapper ){
            let $overlay = $( '.aw-modal-overlay' );
            let $article = $( 'article' );

            if ( ( !$overlay || !$overlay.length ) ){
            $body.append( '<div class="aw-modal-overlay hide"></div>' );
            $overlay = $( '.aw-modal-overlay' );

            }

            $body.addClass( 'aw-modal-visible' );
            $mainContentEl.removeClass( 'main-content' );
            $overlay.removeClass( 'hide' );
            $modalWrapper.addClass( 'aw-modal-visible' );

            awUpdateUrlHash( $modalWrapper );
        }

        window.awHideModal = function(){
            let $overlay = $( '.aw-modal-overlay' );
            $overlay.addClass( 'hide' );

            $body.removeClass( 'aw-modal-visible' );
            $mainContentEl.addClass( 'main-content' );

            $( '.aw-modal-wrapper' ).removeClass( 'aw-modal-visible' );
            awUpdateUrlHash();
        }

        window.awUpdateUrlHash = function( $modalWrapper ){
            let hash = null;

            if ( window.history.replaceState ){
                if ( $modalWrapper && $modalWrapper.is( ':visible' ) ){
                    const idAttr = $modalWrapper.attr( 'id' );
                    if ( idAttr ){
                        hash = `#${ idAttr }`;
                    }
                } else {
                    hash = window.location.pathname + window.location.search;
                }

                window.history.replaceState( null, null, hash );
            }
        }

        $( document ).on( 'click', '.aw-modal-trigger', function( ev ){
            ev.preventDefault();

            let $modalTrigger = $( this );
            let $modalWrapper = $modalTrigger.next( '.aw-modal-wrapper' );
            awShowModal( $modalWrapper );

            return false;
        } );

        $( document ).on( 'click', '.aw-modal-overlay', function(){
            awHideModal();
        } );

        $( document ).keyup( function( e ) {
            if ( e.key === 'Escape' ) {
                awHideModal();
            }
        } );

        $( '.aw-modal-header span' ).on( 'click', function(){
            awHideModal(); 
        } );

        $( '.aw-modal-close' ).on( 'click', function( ev ){
            ev.preventDefault();
            awHideModal(); 
        } );

        $( '.ibm-img-alt-trigger' ).on( 'click', function(){
            let $modalWrapper = $( this ).parent().find( '.aw-modal-wrapper' );
            awShowModal( $modalWrapper );
        } )
 
        if($('body').hasClass('single-aw_learning')){
            $('body').append($('.modal'));
        }
        
        if($('body').hasClass('user-profile-settings-page')){
            $('body').append($('.aw-modal-wrapper'));
        }
    });

} )( jQuery );
